var numSlick = 0;

$('.carousel-block').each(function () {
    numSlick++;

    // Carousel Main
    $(this).find('.slider-main').addClass('slider-main-' + numSlick).slick({
        appendDots: $(this).find('.carousel-indicators'),
        appendArrows: $(this).find('.carousel-indicators'),
        arrows: true,
        autoplay: true,
        autoplaySpeed: 6000,
        prevArrow: '<button class="arrow arrow-sm arrow-left"><span class="sr-only" style="color: white;">Previous</span></button>',
        nextArrow: '<button class="arrow arrow-sm arrow-right slick-next"><span class="sr-only" style="color: white;">Next</span></button>',
        dots: true,
        fade: true,
        infinite: false,
        respondTo: 'slider',
        rows: 0,
        slide: '.carousel-item',
        slidesToScroll: 1,
        slidesToShow: 1,
        asNavFor: '.slider-img',
        accessibility: false
    });

    // Carousel Image
    $(this).find('.slider-img').addClass('slider-img-' + numSlick).slick({
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        asNavFor: '.slider-main',
        focusOnSelect: true,
        infinite: false,
        fade: true,
        slide: '.carousel-img',
        accessibility: false
    });

});

$('.carousel-hero').slick({
    prevArrow: '<button class="slick-prev"><span class="sr-only">Previous</span></button>',
    nextArrow: '<button class="slick-next"><span class="sr-only">Next</span></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    accessibility: false,
});

$('.carousel-photo-slider').slick({
    prevArrow: '<button class="slick-prev"><span class="sr-only">Previous</span></button>',
    nextArrow: '<button class="slick-next"><span class="sr-only">Next</span></button>',
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    accessibility: false,
    adaptiveHeight: true,
    arrows: true,
    autoplay: true,
    dots: true,
    fade: false,
    infinite: true,
});
